import React from 'react'
import { Outlet } from 'react-router-dom'

function PaymentLayout() {
  return (
    <>
        <Outlet />
    </>
  )
}

export default PaymentLayout